import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

import { spacing } from '@mui/system';
import { IconButton, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

type Props = {
  search: string;
  onChange: (value: string) => void;
  label: string;
};

const StyledSearch = styled(TextField)(({ theme }) => ({
  margin: 0,
  '& .MuiInputLabel-shrink': {
    lineHeight: theme.spacing(2),
    transform: 'translate(12px, 9px) scale(0.75)',
    color: theme.palette.text.secondary,
    '& + .MuiFilledInput-root > .MuiInputBase-input': {
      ...spacing({ paddingTop: 3, paddingBottom: 1 }),
    },
  },
  '& .MuiInputBase-input': {
    ...spacing({ paddingX: 1.5, paddingY: 2 }),
    fontSize: theme.spacing(2),
    lineHeight: theme.spacing(3),
  },
  '& .MuiFilledInput-root': {
    '&::before': { borderBottom: 'none' },
    '&::after': { borderBottom: 'none !important' },
    '&:hover, &:active': { backgroundColor: `${theme.palette.primary.light} !important` },
    backgroundColor: `${theme.palette.primary.light} !important`,
    borderColor: theme.palette.text.primary,
  },
}));

const SearchField = ({ search, onChange, label }: Props) => {
  return (
    <StyledSearch
      data-testid="application-search"
      id="application-search"
      label={label}
      name="search"
      variant="filled"
      value={search}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
      }}
      InputProps={{
        endAdornment: search && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => onChange('')}
              edge="end"
              aria-label="clear input"
            >
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchField;
